<template>
  <div class="thai-hilo-main-bet">
    <div class="grid">
      <div class="item">
        <new-bet-lot
          class="thai-hilo-main-bet-betlot"
          gameType="thai_hilo"
          game="thai-hilo-main"
          :type="highOdd"
          :win="winCellNo === highOdd"
          :odd="odd(highOdd)"
          :game-data="gameData"
          :minutes-string="minutesString"
          :seconds-string="secondsString"
          :disallow-betting="disallowBetting"
          :stake-record-sum="stakeRecordSum(highOdd)"
          @update-session-storage="onUpdateSessionStorage"
        />
      </div>
      <div class="item">
        <new-bet-lot
          class="thai-hilo-main-bet-betlot"
          gameType="thai_hilo"
          game="thai-hilo-main"
          :type="singleNumber6Odd"
          :win="winCellNo === singleNumber6Odd"
          :odd="odd(singleNumber6Odd)"
          :game-data="gameData"
          :minutes-string="minutesString"
          :seconds-string="secondsString"
          :disallow-betting="disallowBetting"
          :stake-record-sum="stakeRecordSum(singleNumber6Odd)"
          @update-session-storage="onUpdateSessionStorage"
        />
      </div>
      <div class="item">
        <new-bet-lot
          class="thai-hilo-main-bet-betlot"
          gameType="thai_hilo"
          game="thai-hilo-main"
          :type="singleNumber4Odd"
          :win="winCellNo === singleNumber4Odd"
          :odd="odd(singleNumber4Odd)"
          :game-data="gameData"
          :minutes-string="minutesString"
          :seconds-string="secondsString"
          :disallow-betting="disallowBetting"
          :stake-record-sum="stakeRecordSum(singleNumber4Odd)"
          @update-session-storage="onUpdateSessionStorage"
        />
      </div>
      <div class="item">
        <new-bet-lot
          class="thai-hilo-main-bet-betlot"
          gameType="thai_hilo"
          game="thai-hilo-main"
          :type="singleNumber5Odd"
          :win="winCellNo === singleNumber5Odd"
          :odd="odd(singleNumber3Odd)"
          :game-data="gameData"
          :minutes-string="minutesString"
          :seconds-string="secondsString"
          :disallow-betting="disallowBetting"
          :stake-record-sum="stakeRecordSum(singleNumber5Odd)"
          @update-session-storage="onUpdateSessionStorage"
        />
      </div>
      <div class="up-rectangle" :class="{active: upActive}" @click="upActiveClass">
        <new-bet-lot
          class="thai-hilo-horizontal-bet-betlot"
          gameType="thai_hilo"
          game="thai-hilo-horizontal"
          :type="sixHighOdd"
          :win="winCellNo === sixHighOdd"
          :odd="odd(sixHighOdd)"
          :game-data="gameData"
          :minutes-string="minutesString"
          :seconds-string="secondsString"
          :disallow-betting="disallowBetting"
          :stake-record-sum="stakeRecordSum(sixHighOdd)"
          displayWords="0"
          @update-session-storage="onUpdateSessionStorage"
        />
      </div>
      <div class="down-rectangle" :class="{active: downActive}" @click="downActiveClass">
        <new-bet-lot
          class="thai-hilo-horizontal-bet-betlot"
          gameType="thai_hilo"
          game="thai-hilo-horizontal"
          :type="fourfiveOdd"
          :win="winCellNo === fourfiveOdd"
          :odd="odd(fourfiveOdd)"
          :game-data="gameData"
          :minutes-string="minutesString"
          :seconds-string="secondsString"
          :disallow-betting="disallowBetting"
          :stake-record-sum="stakeRecordSum(fourfiveOdd)"
          displayWords="0"
          @update-session-storage="onUpdateSessionStorage"
        />
      </div>
      <div class="left-rectangle" :class="{active: leftActive}" @click="leftActiveClass">
        <new-bet-lot
          gameType="thai_hilo"
          game="thai-hilo-vertical"
          :type="fourHighOdd"
          :win="winCellNo === fourHighOdd"
          :odd="odd(fourHighOdd)"
          :game-data="gameData"
          :minutes-string="minutesString"
          :seconds-string="secondsString"
          :disallow-betting="disallowBetting"
          :stake-record-sum="stakeRecordSum(fourHighOdd)"
          displayWords="0"
          @update-session-storage="onUpdateSessionStorage"
        />
      </div>
      <div class="right-rectangle" :class="{active: rightActive}" @click="rightActiveClass">
        <new-bet-lot
          gameType="thai_hilo"
          game="thai-hilo-vertical"
          :type="fivesixOdd"
          :win="winCellNo === fivesixOdd"
          :odd="odd(fivesixOdd)"
          :game-data="gameData"
          :minutes-string="minutesString"
          :seconds-string="secondsString"
          :disallow-betting="disallowBetting"
          :stake-record-sum="stakeRecordSum(fivesixOdd)"
          displayWords="0"
          @update-session-storage="onUpdateSessionStorage"
        />
      </div>
      <div class="middle-rectangle" :class="{active: middleActive}" @click="middleActiveClass">
        <new-bet-lot
          class="thai-hilo-horizontal-bet-betlot"
          gameType="thai_hilo"
          game="thai-hilo-horizontal"
          :type="threefourOdd"
          :win="winCellNo === threefourOdd"
          :odd="odd(threefourOdd)"
          :game-data="gameData"
          :minutes-string="minutesString"
          :seconds-string="secondsString"
          :disallow-betting="disallowBetting"
          :stake-record-sum="stakeRecordSum(threefourOdd)"
          displayWords="0"
          @update-session-storage="onUpdateSessionStorage"
        />
      </div>
    </div>
    <div class="grid">
      <div class="item">
        <new-bet-lot
          class="thai-hilo-main-bet-betlot"
          gameType="thai_hilo"
          game="thai-hilo-main"
          :type="singleNumber1Odd"
          :win="winCellNo === singleNumber1Odd"
          :odd="odd(singleNumber1Odd)"
          :game-data="gameData"
          :minutes-string="minutesString"
          :seconds-string="secondsString"
          :disallow-betting="disallowBetting"
          :stake-record-sum="stakeRecordSum(singleNumber1Odd)"
          @update-session-storage="onUpdateSessionStorage"
        />
      </div>
      <div class="item">
        <new-bet-lot
          class="thai-hilo-main-bet-betlot"
          gameType="thai_hilo"
          game="thai-hilo-main"
          :type="loOdd"
          :win="winCellNo === loOdd"
          :odd="odd(loOdd)"
          :game-data="gameData"
          :minutes-string="minutesString"
          :seconds-string="secondsString"
          :disallow-betting="disallowBetting"
          :stake-record-sum="stakeRecordSum(loOdd)"
          @update-session-storage="onUpdateSessionStorage"
        />
      </div>
      <div class="item">
        <new-bet-lot
          class="thai-hilo-main-bet-betlot"
          gameType="thai_hilo"
          game="thai-hilo-main"
          :type="singleNumber2Odd"
          :win="winCellNo === singleNumber2Odd"
          :odd="odd(singleNumber2Odd)"
          :game-data="gameData"
          :minutes-string="minutesString"
          :seconds-string="secondsString"
          :disallow-betting="disallowBetting"
          :stake-record-sum="stakeRecordSum(singleNumber2Odd)"
          @update-session-storage="onUpdateSessionStorage"
        />
      </div>
      <div class="item">
        <new-bet-lot
          class="thai-hilo-main-bet-betlot"
          gameType="thai_hilo"
          game="thai-hilo-main"
          :type="singleNumber3Odd"
          :win="winCellNo === singleNumber3Odd"
          :odd="odd(singleNumber3Odd)"
          :game-data="gameData"
          :minutes-string="minutesString"
          :seconds-string="secondsString"
          :disallow-betting="disallowBetting"
          :stake-record-sum="stakeRecordSum(singleNumber3Odd)"
          @update-session-storage="onUpdateSessionStorage"
        />
      </div>
      <div class="up-rectangle" :class="{active: upActive}" @click="upActiveClass">
        <new-bet-lot
          class="thai-hilo-horizontal-bet-betlot"
          gameType="thai_hilo"
          game="thai-hilo-horizontal"
          :type="oneLoOdd"
          :win="winCellNo === oneLoOdd"
          :odd="odd(oneLoOdd)"
          :game-data="gameData"
          :minutes-string="minutesString"
          :seconds-string="secondsString"
          :disallow-betting="disallowBetting"
          :stake-record-sum="stakeRecordSum(oneLoOdd)"
          displayWords="0"
          @update-session-storage="onUpdateSessionStorage"
        />
      </div>
      <div class="down-rectangle" :class="{active: downActive}" @click="downActiveClass">
        <new-bet-lot
          class="thai-hilo-horizontal-bet-betlot"
          gameType="thai_hilo"
          game="thai-hilo-horizontal"
          :type="twothreeOdd"
          :win="winCellNo === twothreeOdd"
          :odd="odd(twothreeOdd)"
          :game-data="gameData"
          :minutes-string="minutesString"
          :seconds-string="secondsString"
          :disallow-betting="disallowBetting"
          :stake-record-sum="stakeRecordSum(twothreeOdd)"
          displayWords="0"
          @update-session-storage="onUpdateSessionStorage"
        />
      </div>
      <div class="left-rectangle" :class="{active: leftActive}" @click="leftActiveClass">
        <new-bet-lot
          gameType="thai_hilo"
          game="thai-hilo-vertical"
          :type="onetwoOdd"
          :win="winCellNo === onetwoOdd"
          :odd="odd(onetwoOdd)"
          :game-data="gameData"
          :minutes-string="minutesString"
          :seconds-string="secondsString"
          :disallow-betting="disallowBetting"
          :stake-record-sum="stakeRecordSum(onetwoOdd)"
          displayWords="0"
          @update-session-storage="onUpdateSessionStorage"
        />
      </div>
      <div class="right-rectangle" :class="{active: rightActive}" @click="rightActiveClass">
        <new-bet-lot
          gameType="thai_hilo"
          game="thai-hilo-vertical"
          :type="threeLoOdd"
          :win="winCellNo === threeLoOdd"
          :odd="odd(threeLoOdd)"
          :game-data="gameData"
          :minutes-string="minutesString"
          :seconds-string="secondsString"
          :disallow-betting="disallowBetting"
          :stake-record-sum="stakeRecordSum(threeLoOdd)"
          displayWords="0"
          @update-session-storage="onUpdateSessionStorage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { Row, Col, Button } from "iview";
import NewBetLot from "../../commons/NewBetLot";
import betLotMixin from "../../../mixins/bet-lot-mixin";

export default {
  mixins: [betLotMixin],
  props: ["winCellNo", "game", "gameData"],
  components: {
    Row,
    Col,
    Button,
    NewBetLot
  },
  data() {
    return {
      highOdd: "o1",
      loOdd: "o2",
      singleNumber1Odd: "o11",
      singleNumber2Odd: "o21",
      singleNumber3Odd: "o31",
      singleNumber4Odd: "o41",
      singleNumber5Odd: "o51",
      singleNumber6Odd: "o61",
      threeLoOdd: "o6",
      oneLoOdd: "o7",
      sixHighOdd: "o8",
      fourHighOdd: "o9",
      onetwoOdd: "o70",
      twothreeOdd: "o72",
      threefourOdd: "o73",
      fourfiveOdd: "o76",
      fivesixOdd: "o81",
      upActive: 0,
      downActive: 0,
      leftActive: 0,
      rightActive: 0,
      middleActive: 0
    };
  },
  methods: {
    upActiveClass() {
      this.upActive = 1;
      this.downActive = 0;
      this.leftActive = 0;
      this.rightActive = 0;
      this.middleActive = 0;
    },
    downActiveClass() {
      this.upActive = 0;
      this.downActive = 1;
      this.leftActive = 0;
      this.rightActive = 0;
      this.middleActive = 0;
    },
    leftActiveClass() {
      this.upActive = 0;
      this.downActive = 0;
      this.leftActive = 1;
      this.rightActive = 0;
      this.middleActive = 0;
    },
    rightActiveClass() {
      this.upActive = 0;
      this.downActive = 0;
      this.leftActive = 0;
      this.rightActive = 1;
      this.middleActive = 0;
    },
    middleActiveClass() {
      this.upActive = 0;
      this.downActive = 0;
      this.leftActive = 0;
      this.rightActive = 0;
      this.middleActive = 1;
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.thai-hilo-number {
  @extend .game-section;
}

.thai-hilo-main-bet {
  width: 100%;
  height: auto;
}

.grid {
  display: inline-grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  height: 150px;
  width: 50%;
  position: relative;
}

.grid:nth-child(2) {
  float: left;
}

.item {
  border: solid 2px orange;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  //   border-radius: 5px;
}

.up-rectangle {
  position: absolute;
  width: 12%;
  height: 50px;
  right: 50%;
  transform: TranslateX(50%);
  z-index: 10;
  top: 8%;
  border: 2px dashed white;
  border-radius: 10px;
  min-width: 25px;
}

.down-rectangle {
  position: absolute;
  width: 12%;
  height: 50px;
  right: 50%;
  transform: TranslateX(50%);
  z-index: 10;
  bottom: 8%;
  border: 2px dashed white;
  border-radius: 10px;
  min-width: 25px;
}

.left-rectangle {
  position: absolute;
  width: 36%;
  height: 25px;
  z-index: 10;
  top: 50%;
  transform: translateY(-50%);
  border: 2px dashed white;
  border-radius: 10px;
  left: 6%;
}

.right-rectangle {
  position: absolute;
  width: 36%;
  height: 25px;
  z-index: 10;
  top: 50%;
  transform: translateY(-50%);
  border: 2px dashed white;
  border-radius: 10px;
  right: 6%;
}

.middle-rectangle {
  position: absolute;
  width: 12%;
  height: 50px;
  left: 0;
  transform: TranslateX(-50%);
  z-index: 10;
  bottom: 8%;
  border: 2px dashed white;
  border-radius: 10px;
  min-width: 25px;
}

.up-rectangle.active,
.down-rectangle.active,
.left-rectangle.active,
.right-rectangle.active,
.middle-rectangle.active {
  z-index: 11;
}

.thai-hilo-main-bet-betlot {
  width: 100%;
  height: 71px;
  position: relative;
  cursor: pointer; //1017 ADDED
}

.thai-hilo-number-title {
  @extend .tai-xiu-game-title;
}

.thai-hilo-number-bet-no {
  @extend .tai-xiu-game-bet-no;
  margin-top: unset;
}

.thai-hilo-number-cell.ivu-btn:before {
  content: "";
  display: block;
  top: 0;
  height: 31%;
  z-index: 0;
}

@media only screen and (max-width: 360px) {
  .thai-hilo-number-bet-no {
    margin-top: 5px;
    font-size: 12px;
  }
}
</style>

<style lang="scss">
.thai-hilo-number-cell.ivu-btn {
  @extend .tai-xiu-game-btn;
}

.thai-hilo-number-cell.ivu-btn:hover .thai-hilo-number-title,
.thai-hilo-number-cell.ivu-btn:hover .thai-hilo-number-bet-no {
  @extend .tai-xiu-game-btn-hover-cell;
}

.thai-hilo-number-cell.ivu-btn:focus {
  @extend .tai-xiu-game-btn-focus;
}

.thai-hilo-number-cell.thai-hilo-number-cell-active.ivu-btn
  .thai-hilo-number-title,
.thai-hilo-number-cell.thai-hilo-number-cell-active.ivu-btn
  .thai-hilo-number-bet-no {
  @extend .tai-xiu-game-btn-active;
}

.thai-hilo-number-cell.ivu-btn:hover {
  @extend .tai-xiu-game-btn-hover;
}
</style>
